import { useEffect } from 'react';
import { getDocument } from '@atlaskit/browser-apis';
import { useAIEventsInstrumentation } from '@atlassian/ai-analytics/use-ai-events-instrumentation';

export const useTrackAIInteractionDismissOnTabClose = (): void => {
	const { trackAIInteractionDismiss } = useAIEventsInstrumentation();

	useEffect(() => {
		const win = getDocument()?.defaultView;
		if (win == null) {
			return;
		}

		function onPageHide() {
			trackAIInteractionDismiss();
		}

		win.addEventListener('pagehide', onPageHide);

		return () => {
			win.removeEventListener('pagehide', onPageHide);
		};
	}, [trackAIInteractionDismiss]);
};
